'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFontawesome = require('@fortawesome/react-fontawesome');
var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * A component that allows the user to enter text to search.
 */
var SearchBoxBase = function (_React$Component) {
  _inherits(SearchBoxBase, _React$Component);
  function SearchBoxBase(props) {
    _classCallCheck(this, SearchBoxBase);
    var _this = _possibleConstructorReturn(this, (SearchBoxBase.__proto__ || Object.getPrototypeOf(SearchBoxBase)).call(this, props));
    _this.state = {
      searchValue: '',
      isCancelable: false
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleCancelSearchButtonClick = _this.handleCancelSearchButtonClick.bind(_this);
    _this.handleSearchDebounced = _this.getHandleSearchDebounced().bind(_this);
    return _this;
  }
  _createClass(SearchBoxBase, [{
    key: 'render',
    value: function () {
      function render() {
        var searchValue = this.state.searchValue;
        var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          placeholder = _props.placeholder;
        return _react2['default'].createElement('div', {
          className: className
        }, _react2['default'].createElement('div', {
          name: 'searchButtonContainer',
          onClick: this.handleSearch
        }, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _freeSolidSvgIcons.faSearch
        })), _react2['default'].createElement('div', {
          name: 'textboxContainer'
        }, _react2['default'].createElement('input', {
          disabled: disabled,
          onChange: this.handleChange,
          onKeyDown: this.handleKeyPress,
          placeholder: placeholder,
          type: 'text',
          value: searchValue
        }), this.renderCancelButton()));
      }
      return render;
    }()
  }, {
    key: 'renderCancelButton',
    value: function () {
      function renderCancelButton() {
        var isCancelable = this.state.isCancelable;
        if (isCancelable) {
          return _react2['default'].createElement('div', {
            name: 'cancelButtonContainer',
            onClick: this.handleCancelSearchButtonClick
          }, _react2['default'].createElement(_reactFontawesome.FontAwesomeIcon, {
            icon: _freeSolidSvgIcons.faTimesCircle
          }));
        }
        return null;
      }
      return renderCancelButton;
    }()
  }, {
    key: 'handleChange',
    value: function () {
      function handleChange(evt) {
        var _this2 = this;
        var _props2 = this.props,
          debounced = _props2.debounced,
          disabled = _props2.disabled;
        if (!disabled) {
          this.setState({
            searchValue: evt.target.value || ''
          }, function () {
            if (debounced) {
              _this2.handleSearchDebounced(_this2.state.searchValue, evt);
            }
          });
        }
      }
      return handleChange;
    }()
  }, {
    key: 'handleKeyPress',
    value: function () {
      function handleKeyPress(evt) {
        var ENTER_KEY_CODE = 13;
        var ESCAPE_KEY_CODE = 27;
        if (evt.keyCode === ENTER_KEY_CODE) {
          this.handleSearch(evt);
        } else if (evt.keyCode === ESCAPE_KEY_CODE) {
          this.handleCancelSearchButtonClick(evt);
        }
      }
      return handleKeyPress;
    }()
  }, {
    key: 'handleSearch',
    value: function () {
      function handleSearch(evt) {
        var _this3 = this;
        var searchValue = this.state.searchValue;
        var _props3 = this.props,
          debounced = _props3.debounced,
          disabled = _props3.disabled,
          searchHandler = _props3.searchHandler;
        if (!disabled) {
          var isCancelable = searchValue.length > 0;
          this.setState({
            isCancelable: isCancelable
          }, function () {
            if (debounced) {
              _this3.handleSearchDebounced(searchValue, evt);
            } else {
              searchHandler(searchValue, evt);
            }
          });
        }
      }
      return handleSearch;
    }()
  }, {
    key: 'handleCancelSearchButtonClick',
    value: function () {
      function handleCancelSearchButtonClick(evt) {
        var _this4 = this;
        var _props4 = this.props,
          debounced = _props4.debounced,
          searchHandler = _props4.searchHandler;
        this.setState({
          isCancelable: false,
          searchValue: ''
        }, function () {
          if (debounced) {
            _this4.handleSearchDebounced('', evt);
          } else {
            searchHandler('', evt);
          }
        });
      }
      return handleCancelSearchButtonClick;
    }()
  }, {
    key: 'getHandleSearchDebounced',
    value: function () {
      function getHandleSearchDebounced() {
        var _this5 = this;
        var DEBOUNCE_TIMEOUT = 500;
        var searchHandler = this.props.searchHandler;
        return _lodash2['default'].debounce(function (searchValue, evt) {
          var isCancelable = searchValue.length > 0;
          _this5.setState({
            isCancelable: isCancelable
          }, function () {
            searchHandler(searchValue, evt);
          });
        }, DEBOUNCE_TIMEOUT);
      }
      return getHandleSearchDebounced;
    }()
  }]);
  return SearchBoxBase;
}(_react2['default'].Component);
SearchBoxBase.propTypes = {
  /**
   * Boolean to trigger a search that responds on keypress and is debounced.
   */
  debounced: _propTypes2['default'].bool,
  /**
   * Control will be disabled when this value is true. Default is false.
   */
  disabled: _propTypes2['default'].bool,
  /**
   * Placeholder text for the Search Bar.
   */
  placeholder: _propTypes2['default'].string,
  /**
   * Function called when the search value changes.
   * @param {string} searchValue the search value for the search box.
   * @param {object} evt The event object.
   */
  searchHandler: _propTypes2['default'].func
};
SearchBoxBase.defaultProps = {
  debounced: false,
  disabled: false,
  placeholder: '',
  searchHandler: function () {
    function searchHandler() {}
    return searchHandler;
  }()
};
SearchBoxBase.displayName = 'SearchBox';
exports['default'] = SearchBoxBase;